import { Reveal } from "../components/Reveal";
import { ScoreBar } from "../components/ScoreBar";
import { SampleTag } from "../components/SampleTag";
import { REPORT } from "../data/sampleData";

const SampleReport = () => (
    <main className="py-20 md:py-28" data-testid="report-page">
        <div className="wrap">
            <Reveal className="flex flex-col gap-4 sm:flex-row sm:items-end sm:justify-between">
                <div>
                    <p className="eyebrow">Sample report</p>
                    <h2 className="mt-4 max-w-2xl text-3xl leading-tight tracking-tight sm:text-4xl lg:text-5xl">
                        What you take <em className="italic text-brass">home.</em>
                    </h2>
                </div>
                <SampleTag />
            </Reveal>

            <Reveal delay={0.1} className="mt-14">
                <div
                    className="border border-line bg-surface"
                    data-testid="report-scorecard"
                >
                    <div className="flex flex-col gap-2 border-b border-line px-7 py-6 sm:flex-row sm:items-baseline sm:justify-between sm:px-10">
                        <div>
                            <p className="font-display text-2xl tracking-tight">
                                {REPORT.candidate}
                            </p>
                            <p className="mt-1 text-xs text-ink-muted">
                                {REPORT.exam} · {REPORT.board}
                            </p>
                        </div>
                        <p className="text-xs tabular-nums text-ink-muted">
                            {REPORT.date}
                        </p>
                    </div>

                    <div className="grid gap-12 px-7 py-10 sm:px-10 lg:grid-cols-2 lg:gap-16">
                        <div className="space-y-7">
                            {REPORT.scores.map((s, i) => (
                                <ScoreBar
                                    key={s.label}
                                    label={s.label}
                                    score={s.score}
                                    delay={i * 0.08}
                                />
                            ))}
                            <div className="flex items-baseline justify-between border-t border-line pt-6">
                                <p className="text-[11px] font-medium uppercase tracking-[0.2em] text-ink-muted">
                                    Overall
                                </p>
                                <p
                                    className="font-display tabular-nums"
                                    data-testid="report-overall-score"
                                >
                                    <span className="text-4xl">{REPORT.overall}</span>
                                    <span className="ml-1 text-sm text-ink-muted">/ 10</span>
                                </p>
                            </div>
                        </div>

                        <div className="flex flex-col justify-between lg:border-l lg:border-line lg:pl-16">
                            <div>
                                <p className="text-[11px] font-medium uppercase tracking-[0.2em] text-ink-muted">
                                    Panel remark
                                </p>
                                <blockquote className="mt-5 font-display text-xl leading-relaxed sm:text-2xl">
                                    <span className="mr-1 text-brass">“</span>
                                    {REPORT.remark}
                                    <span className="ml-1 text-brass">”</span>
                                </blockquote>
                                <p className="mt-6 text-sm italic text-ink-muted">
                                    {REPORT.signOff}
                                </p>
                                <div className="mt-6 flex flex-wrap gap-2" data-testid="remark-tags">
                                    <span className="border border-brass px-3 py-1 text-[11px] uppercase tracking-[0.14em] text-brass">
                                        Focus · {REPORT.remarkTags.primary_focus}
                                    </span>
                                    <span className="border border-line px-3 py-1 text-[11px] uppercase tracking-[0.14em] text-ink-muted">
                                        Tone · {REPORT.remarkTags.tone}
                                    </span>
                                    <span className="border border-line px-3 py-1 text-[11px] uppercase tracking-[0.14em] text-ink-muted">
                                        Actionable · {Math.round(REPORT.remarkTags.actionable * 100)}%
                                    </span>
                                </div>
                                <p className="mt-3 text-xs text-ink-muted">
                                    Tags auto-assigned by Jev on the Universal Key.
                                </p>
                            </div>
                            <p className="mt-10 text-xs leading-relaxed text-ink-muted">
                                Names, scores and remarks are sample content —
                                replace them in src/data/sampleData.js.
                            </p>
                        </div>
                    </div>
                </div>
            </Reveal>
        </div>
    </main>
);

export default SampleReport;
